import { cn } from "@/lib/utils"

// Base skeleton - matches Next.js exactly
function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("animate-pulse rounded-md bg-slate-200 dark:bg-slate-800", className)}
      {...props}
    />
  )
}

export { Skeleton }
